import Change from '../components/Change'

export default function formatPerentChange({ change }) {
  return <Change as="span" change={change} percent />
}
